import WPhoto_PolaroidPhotoComponent from '@wix/thunderbolt-elements/src/components/WPhoto/viewer/skinComps/BasicWPhoto/PolaroidPhoto.skin';
import WPhoto_PolaroidPhotoController from '@wix/thunderbolt-elements/src/components/WPhoto/viewer/WPhoto.controller';


const WPhoto_PolaroidPhoto = {
  component: WPhoto_PolaroidPhotoComponent,
  controller: WPhoto_PolaroidPhotoController
};


export const components = {
  ['WPhoto_PolaroidPhoto']: WPhoto_PolaroidPhoto
};

